import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { key: 0 }

import Button from "@/components/button.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'confirmation',
  props: /*@__PURE__*/_mergeModels({
    callback: {
      default: null,
      required: true,
      type: Function
    },
    message: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  }, {
    "display": {
    default: null,
    required: true,
    type: Boolean
  },
    "displayModifiers": {},
  }),
  emits: ["update:display"],
  setup(__props) {

  
  
  const display = _useModel(__props, "display")

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (display.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("h1", null, _toDisplayString(__props.title), 1),
              (__props.message)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.message), 1))
                : _createCommentVNode("", true),
              _createVNode(Button, {
                title: "Cancel",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (display.value = false))
              }),
              _createVNode(Button, {
                title: "Confirm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.callback()))
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})